import { mapGetters } from 'vuex'
import TrackerDataTablePaginatedMixin from '@/applications/scrum/components/TrackerDataTable/TrackerDataTablePaginated'

export default {
  name: 'TrackerDataTablePaginated',
  mixins: [TrackerDataTablePaginatedMixin],

  computed: {
    ...mapGetters({
      'applicationId': 'contextStore/applicationId',
      dataTableById: 'contextStore/trackerDataTableById'
    })
  },

  methods: {
    async fetchKanbanDataHook (trackerDTO) {
      let workpackages = []
      let parentTrackerDTO = null

      // Load parent tracker
      if (trackerDTO.parentId) {
        const url = this.$axios.agilisUrlTrackerParents(
          this.applicationId,
          trackerDTO.trackerTypeId,
          trackerDTO.id)
        const parentsResponse = await this.$axios.get(
          url,
          this.$axios.agilisRequestConfig(url)
        )
        let parentTracker = parentsResponse.data?.parentTracker?.tracker
        const urlParent = this.$axios.agilisUrlTrackerEdit(this.applicationId, parentTracker.trackerTypeId, parentTracker.id)
        const parentTrackerGetResponse = await this.$axios.get(
          urlParent,
          this.$axios.agilisRequestConfig(urlParent)
        )
        parentTracker = parentTrackerGetResponse.data
        parentTrackerDTO = parentTracker
      }

      // Load workpackages
      const urlWP = `/api/${this.applicationId}/tracker/${trackerDTO.trackerTypeId}/${trackerDTO.id}/workpackage`
      const responseWP = await this.$axios.get(urlWP, this.$axios.agilisRequestConfig(urlWP))
      workpackages = responseWP.data

      this.$refs.kanban.setJlAssertionContext({
        workpackages,
        parentTrackerDTO
      })
    }
  }
}
